var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddchartRounded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AddchartRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 10C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10V17H11V10ZM20 13C19.45 13 19 13.45 19 14V19H5V5H10C10.55 5 11 4.55 11 4C11 3.45 10.55 3 10 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V14C21 13.45 20.55 13 20 13ZM21 5H19V3C19 2.45 18.55 2 18 2C17.45 2 17 2.45 17 3V5H15C14.45 5 14 5.45 14 6C14 6.55 14.45 7 15 7H17V9C17 9.55 17.45 10 18 10C18.55 10 19 9.55 19 9V7H21C21.55 7 22 6.55 22 6C22 5.45 21.55 5 21 5ZM16 13C15.45 13 15 13.45 15 14V17H17V14C17 13.45 16.55 13 16 13ZM7 12V17H9V12C9 11.45 8.55 11 8 11C7.45 11 7 11.45 7 12Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddchartRounded);
export default __webpack_public_path__ + "static/media/addchart-rounded.474eea09c00d24f05a309177182ddb34.svg";
export { ForwardRef as ReactComponent };